// extracted by mini-css-extract-plugin
export default {"header":"styles_header__OP2UH","overskrift":"styles_overskrift__w+F8D","iconContainer":"styles_iconContainer__Uhdan"};